// v2 campaign catalog lane — owned by the same agent as app/v2/slot2.tsx. Do not edit
// from another lane. One entry per shipped v2 page.
import type { V2CatalogEntry } from './types';

export const slot2Catalog: V2CatalogEntry[] = [
  {
    rank: 10,
    title: 'Truck Dispatch',
    route: '/truck/dispatch2',
    faithfulRoute: '/browse/trucks',
    score: 18,
    blurb:
      "The truck's whole lifecycle as one timeline with the next legal Manage Truck step named on the button, a fleet band that shows what is stuck, and a documents cluster that states each print's prerequisite before you click it.",
  },
  {
    rank: 13,
    title: 'Truck Status Detail',
    route: '/truck/status-detail2',
    faithfulRoute: '/shipping/truck-status-detail/:warehouseId/:truckId',
    score: 18,
    blurb:
      '"Is this truck ready to close?" answered up front from the Orders tab\'s own totals, with the seven PB tabs regrouped into what is committed versus what is physically on the truck and every drill target named on the row.',
  },
  {
    rank: 28,
    title: 'Dock Door Manager',
    route: '/truck/dock2',
    faithfulRoute: '/browse/dock-manager-door',
    score: 17,
    blurb:
      'Yard health above the board — doors occupied, blocked, trucks waiting, detention split W/C, longest dwell — with doors grouped by state and every direction-gated action named instead of greyed. Drag-and-drop stays the only dock path.',
  },
  {
    rank: 25,
    title: 'Shipping Station',
    route: '/ship/station2',
    faithfulRoute: '/ship/station',
    score: 17,
    blurb:
      'A ship-readiness checklist that explains every grey button instead of leaving you to guess — station, carton, ship method + carrier, freight terms, weight, dims, address — over three panes, with each action showing the scan keyword that fires it and the scan field always taking focus back.',
  },
  {
    rank: 29,
    title: 'Carton Lookup',
    route: '/cartons/lookup2',
    faithfulRoute: '/cartons/lookup',
    score: 17,
    blurb:
      'The carton\'s state decoded in the header band — status C/H/M in words, verified, shipped, a picked/to-move meter — with PB\'s hidden tabs kept in the rail with the reason they are hidden, and the three destructive actions named and preconditioned instead of greyed icons.',
  },
  {
    rank: 30,
    title: 'Shipping Process console',
    route: '/ship/console2',
    faithfulRoute: '/browse/ship-shipping',
    score: 17,
    blurb:
      'One search, every source: the rail is Current / History / Misc / Ship Down with its own row count for your key, so a carton that fell through to if_ship_dwn stops costing four searches — over a shipped/held/voided split, a missing-tracking exception count, and Ship / Void / Rel Hold with the state gate stated.',
  },
  {
    rank: 27,
    title: 'Truck Load Waving',
    route: '/orders/truck-load-waving2',
    faithfulRoute: '/orders/truck-load-waving',
    score: 17,
    blurb:
      'A live "does it fit?" band — orders, weight, cube, lines and pieces for what is on the truck, what the selection would add, and the projected total — plus stop/load sequence duplicates and gaps raised before Save Seq Numbers can fail, over a rail that is the three real stages: Pick orders / Build the truck / Wave it.',
  },
  {
    rank: 15,
    title: 'Kit Run',
    route: '/kit-runs2',
    faithfulRoute: '/kit-runs/:warehouseId/:kitRun',
    score: 18,
    blurb:
      'The estimate stops being a button: run completion and "short by N; K components constrain this run" are on the header, with the constraining components named, and the 15-icon toolbar becomes a Prepare → Generate → Run → Finish ladder whose current rung follows process_status.',
  },
  {
    rank: 44,
    title: 'QC Inspect',
    route: '/qc/inspect2',
    faithfulRoute: '/qc/inspect',
    score: 16,
    blurb:
      'The station queue up front — lines waiting, pieces to inspect, the QC-rule split and the "Last" container as a real card — with the steps as a Pass/Fail/Un-inspected strip and a Confirm card that shows the arithmetic ("120 inspected, 8 fail, 8 deplete → 112 released") before you commit.',
  },
  {
    // slice-3688 — NOT a v2_wins.html row: built for the demo "New Screens" slider
    // (docs/demochanges.txt, CHRIS 2026-09-17, "If any do NOT have a v2 screen yet, then
    // please go ahead and create it"). Ranked after the 50 surveyed screens; the score is
    // this lane's own read of the same rubric, not a survey figure.
    rank: 51,
    title: 'Adjust Inventory Search',
    route: '/browse/adjust-search2',
    faithfulRoute: '/browse/adjust-search',
    score: 17,
    blurb:
      'The four Search-For grains become the rail instead of a radio that silently reinterprets every criterion and column below it, each with its criteria regrouped into named question bands — over a result band that answers "did I find what I meant?" (pieces onhand, items, locations, on hold, blocked) and a composition bar whose segments narrow the 45-to-60-column grid client-side, with the three grey zoom icons named, preconditioned and stating which one the double-click will repeat.',
  },
];
